<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title" id="billAdjustmentLabel">Bill Adjustment</h5>
      <button
        type="button"
        class="btn-close"
        ref="modalCloseBtn"
        data-bs-dismiss="modal"
        aria-label="Close"
      ></button>
    </div>
    <form @submit.prevent="adjustBill()">
      <div class="modal-body">
        <div class="row">
          <div class="col-sm-6">
            <label for="amount_type" class="col-form-label">Amount Type:</label>
            <select
              class="form-select"
              v-model="formValue.amountType"
              id="amount_type"
              required
            >
              <option value="">Select One</option>
              <option value="addition">Addition</option>
              <option value="deduction">Deduction</option>
            </select>
          </div>
          <div class="col-sm-6">
            <label for="amount" class="col-form-label">Amount:</label>
            <input
              type="number"
              v-model="formValue.amount"
              class="form-control"
              required
            />
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <label for="reason" class="col-form-label">Reason:</label>
            <textarea
              class="form-control"
              v-model="formValue.reason"
              required
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button type="submit" class="btn btn-primary">Save changes</button>
      </div>
    </form>
  </div>
</template>

<script>
import http from '../../config/axios';

export default {
  props: ['billId', 'driverCode', 'ownerCode'],
  data() {
    return {
      formValue: {
        bill_id: null,
        amount: null,
        ownerID: null,
        driverCode: null,
        amountType: '',
        reason: ''
      }
    };
  },
  watch: {
    billId: {
      handler() {
        this.formValue.bill_id = this.billId;
        this.emptyFormData();
      },
      deep: true
    },
    ownerCode: {
      handler() {
        this.formValue.ownerID = this.ownerCode;
        this.emptyFormData();
      },
      deep: true
    },
    driverCode: {
      handler() {
        this.formValue.driverCode = this.driverCode;
        this.emptyFormData();
      },
      deep: true
    }
  },
  methods: {
    emptyFormData() {
      this.formValue.amountType = '';
      this.formValue.amount = null;
      this.formValue.reason = '';
    },
    adjustBill() {
      http
        .post(
          `/v2/partners/bills/adjustment/${this.formValue.bill_id}`,
          this.formValue
        )
        .then((response) => {
          if (response.status === 200) {
            this.emptyFormData();
            this.$emit('syncBillData');
            this.$swal('Success', response.data.message, 'success');
            this.$refs.modalCloseBtn.click();
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.errored = true;
          this.$swal({
            icon: 'error',
            title: 'Error',
            text: error.response.data?.message
          });
        });
    }
  }
};
</script>
